module.exports = __webpack_public_path__ + "static/media/liveclass.5dfdd8c5.png";